import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './SavedWorkouts.css';

// COMPLETE trainer data array - all 156 trainers from your landing page
const trainerData = [
    { name: "Spider-Man", url: "https://test1.7lore.com/hero-trainers/spider-man" },
    { name: "Captain America", url: "https://test1.7lore.com/hero-trainers/captain-america" },
    { name: "Wolverine", url: "https://test1.7lore.com/hero-trainers/wolverine" },
    { name: "Deadpool", url: "https://test1.7lore.com/hero-trainers/deadpool" },
    { name: "Iron Man", url: "https://test1.7lore.com/hero-trainers/iron-man" },
    { name: "Thor", url: "https://test1.7lore.com/hero-trainers/thor" },
    { name: "Sarah Chen", url: "https://test1.7lore.com/trainer/sarah-chen" },
    { name: "Marcus Steel", url: "https://test1.7lore.com/trainer/marcus-steel" },
    { name: "Phoenix Wright", url: "https://test1.7lore.com/trainer/phoenix-wright" },
    { name: "Alex Steele", url: "https://test1.7lore.com/trainer/alex-steele" },
    { name: "Jack Reynolds", url: "https://test1.7lore.com/trainer/jack-reynolds" },
    { name: "Mike Johnson", url: "https://test1.7lore.com/trainer/mike-johnson" },
    { name: "Marcus Blackwood", url: "https://test1.7lore.com/advanced-trainer/marcus-blackwood" },
    { name: "Dante Rivera", url: "https://test1.7lore.com/advanced-trainer/dante-rivera" },
    { name: "Ethan Harris", url: "https://test1.7lore.com/advanced-trainer/ethan-harris" },
    { name: "Victor Stone", url: "https://test1.7lore.com/advanced-trainer/victor-stone" },
    { name: "Logan Reeves", url: "https://test1.7lore.com/advanced-trainer/logan-reeves" },
    { name: "Derek Cruz", url: "https://test1.7lore.com/advanced-trainer/derek-cruz" },
    { name: "Axel Ironside", url: "https://test1.7lore.com/strength-trainer/axel-ironside" },
    { name: "Magnus Steele", url: "https://test1.7lore.com/strength-trainer/magnus-steele" },
    { name: "Brock Hammer", url: "https://test1.7lore.com/strength-trainer/brock-hammer" },
    { name: "Kane Titanium", url: "https://test1.7lore.com/strength-trainer/kane-titanium" },
    { name: "Rex Savage", url: "https://test1.7lore.com/strength-trainer/rex-savage" },
    { name: "Dominic Stone", url: "https://test1.7lore.com/strength-trainer/dominic-stone" },
    { name: "Oliver Bennett", url: "https://test1.7lore.com/bands-trainer/oliver-bennett" },
    { name: "Max Rodriguez", url: "https://test1.7lore.com/bands-trainer/max-rodriguez" },
    { name: "Zoe Harper", url: "https://test1.7lore.com/bands-trainer/zoe-harper" },
    { name: "Nathan Brooks", url: "https://test1.7lore.com/bands-trainer/nathan-brooks" },
    { name: "Jasmine Carter", url: "https://test1.7lore.com/bands-trainer/jasmine-carter" },
    { name: "Caleb Mitchell", url: "https://test1.7lore.com/bands-trainer/caleb-mitchell" },
    { name: "Zephyr Blackstone", url: "https://test1.7lore.com/everything-trainer/zephyr-blackstone" },
    { name: "Atlas Kaine", url: "https://test1.7lore.com/everything-trainer/atlas-kaine" },
    { name: "Orion Phoenix", url: "https://test1.7lore.com/everything-trainer/orion-phoenix" },
    { name: "Vortex Shadowstone", url: "https://test1.7lore.com/everything-trainer/vortex-shadowstone" },
    { name: "Talon Wolfe", url: "https://test1.7lore.com/everything-trainer/talon-wolfe" },
    { name: "Nova Steelheart", url: "https://test1.7lore.com/everything-trainer/nova-steelheart" },
    { name: "Uesugi Kenshin", url: "https://test1.7lore.com/japan-trainer/uesugi-kenshin" },
    { name: "Tokugawa Ieyasu", url: "https://test1.7lore.com/japan-trainer/tokugawa-ieyasu" },
    { name: "Theodore Roosevelt", url: "https://test1.7lore.com/history-trainer/theodore-roosevelt" },
    { name: "Tengu Master", url: "https://test1.7lore.com/japan-trainer/tengu-master" },
    { name: "Tea Master Sen no Rikyu", url: "https://test1.7lore.com/japan-trainer/tea-master-sen-no-rikyu" },
    { name: "Takeda Shingen", url: "https://test1.7lore.com/japan-trainer/takeda-shingen" },
    { name: "Sumo Grand Champion", url: "https://test1.7lore.com/japan-trainer/sumo-grand-champion" },
    { name: "Spartacus", url: "https://test1.7lore.com/history-trainer/spartacus" },
    { name: "Sohei Warrior Monk", url: "https://test1.7lore.com/japan-trainer/sohei-warrior-monk" },
    { name: "Sarutobi Sasuke", url: "https://test1.7lore.com/japan-trainer/sarutobi-sasuke" },
    { name: "Saito Hajime", url: "https://test1.7lore.com/japan-trainer/saito-hajime" },
    { name: "Rasputin", url: "https://test1.7lore.com/history-trainer/rasputin" },
    { name: "Prince Shotoku", url: "https://test1.7lore.com/japan-trainer/prince-shotoku" },
    { name: "Pablo Picasso", url: "https://test1.7lore.com/history-trainer/pablo-picasso" },
    { name: "P.T. Barnum", url: "https://test1.7lore.com/history-trainer/p-t-barnum" },
    { name: "Oscar Wilde", url: "https://test1.7lore.com/history-trainer/oscar-wilde" },
    { name: "Onmyoji Mystic", url: "https://test1.7lore.com/japan-trainer/onmyoji-mystic" },
    { name: "Oda Nobunaga", url: "https://test1.7lore.com/japan-trainer/oda-nobunaga" },
    { name: "Noh Master", url: "https://test1.7lore.com/japan-trainer/noh-master" },
    { name: "Nikola Tesla", url: "https://test1.7lore.com/history-trainer/nikola-tesla" },
    { name: "Napoleon Bonaparte", url: "https://test1.7lore.com/history-trainer/napoleon-bonaparte" },
    { name: "Miyamoto Musashi", url: "https://test1.7lore.com/japan-trainer/miyamoto-musashi" },
    { name: "Minamoto no Yoshitsune", url: "https://test1.7lore.com/japan-trainer/minamoto-no-yoshitsune" },
    { name: "Minamoto no Yoritomo", url: "https://test1.7lore.com/japan-trainer/minamoto-no-yoritomo" },
    { name: "Michelangelo", url: "https://test1.7lore.com/history-trainer/michelangelo" },
    { name: "Marco Polo", url: "https://test1.7lore.com/history-trainer/marco-polo" },
    { name: "Lewis & Clark", url: "https://test1.7lore.com/history-trainer/lewis-clark" },
    { name: "Kyudo Archer", url: "https://test1.7lore.com/japan-trainer/kyudo-archer" },
    { name: "King Leonidas", url: "https://test1.7lore.com/history-trainer/king-leonidas" },
    { name: "Kendo Master", url: "https://test1.7lore.com/japan-trainer/kendo-master" },
    { name: "Kabuki Actor", url: "https://test1.7lore.com/japan-trainer/kabuki-actor" },
    { name: "Julius Caesar", url: "https://test1.7lore.com/history-trainer/julius-caesar" },
    { name: "Jiraiya", url: "https://test1.7lore.com/japan-trainer/jiraiya" },
    { name: "Isaac Newton", url: "https://test1.7lore.com/history-trainer/isaac-newton" },
    { name: "Ikebana Master", url: "https://test1.7lore.com/japan-trainer/ikebana-master" },
    { name: "Honda Tadakatsu", url: "https://test1.7lore.com/japan-trainer/honda-tadakatsu" },
    { name: "Hattori Hanzo", url: "https://test1.7lore.com/japan-trainer/hattori-hanzo" },
    { name: "Hannibal Barca", url: "https://test1.7lore.com/history-trainer/hannibal-barca" },
    { name: "Geisha Master", url: "https://test1.7lore.com/japan-trainer/geisha-master" },
    { name: "Galileo Galilei", url: "https://test1.7lore.com/history-trainer/galileo-galilei" },
    { name: "Fuma Kotaro", url: "https://test1.7lore.com/japan-trainer/fuma-kotaro" },
    { name: "Ernest Shackleton", url: "https://test1.7lore.com/history-trainer/ernest-shackleton" },
    { name: "Emperor Meiji", url: "https://test1.7lore.com/japan-trainer/emperor-meiji" },
    { name: "Edgar Allan Poe", url: "https://test1.7lore.com/history-trainer/edgar-allan-poe" },
    { name: "Date Masamune", url: "https://test1.7lore.com/japan-trainer/date-masamune" },
    { name: "Cleopatra VII", url: "https://test1.7lore.com/history-trainer/cleopatra-vii" },
    { name: "Christopher Columbus", url: "https://test1.7lore.com/history-trainer/christopher-columbus" },
    { name: "Che Guevara", url: "https://test1.7lore.com/history-trainer/che-guevara" },
    { name: "Boudica", url: "https://test1.7lore.com/history-trainer/boudica" },
    { name: "Blackbeard", url: "https://test1.7lore.com/history-trainer/blackbeard" },
    { name: "Attila the Hun", url: "https://test1.7lore.com/history-trainer/attila-the-hun" },
    { name: "Amelia Earhart", url: "https://test1.7lore.com/history-trainer/amelia-earhart" },
    { name: "Alexander the Great", url: "https://test1.7lore.com/history-trainer/alexander-the-great" },
    { name: "Albert Einstein", url: "https://test1.7lore.com/history-trainer/albert-einstein" },
    { name: "Vincent van Gogh", url: "https://test1.7lore.com/history-trainer/vincent-van-gogh" },
    { name: "Wild Bill Hickok", url: "https://test1.7lore.com/history-trainer/wild-bill-hickok" },
    { name: "Wolfgang Amadeus Mozart", url: "https://test1.7lore.com/history-trainer/wolfgang-amadeus-mozart" },
    { name: "Yamabushi Mountain Ascetic Alt", url: "https://test1.7lore.com/japan-trainer/yamabushi-mountain-ascetic-alt" },
    { name: "Yamabushi Mountain Ascetic", url: "https://test1.7lore.com/japan-trainer/yamabushi-mountain-ascetic" },
    { name: "Zen Monk Master", url: "https://test1.7lore.com/japan-trainer/zen-monk-master" },
    { name: "Sir Percival the Welsh", url: "https://test1.7lore.com/knight-trainer/sir-percival-the-welsh" },
    { name: "Sir Pellimore the Questing Beast Hunter", url: "https://test1.7lore.com/knight-trainer/sir-pellimore-the-questing-beast-hunter" },
    { name: "Sir Brunor le Noir the Black Knight", url: "https://test1.7lore.com/knight-trainer/sir-brunor-le-noir-the-black-knight" },
    { name: "Sir Kay the Seneschal", url: "https://test1.7lore.com/knight-trainer/sir-kay-the-seneschal" },
    { name: "Sir Dinadan the Humorous", url: "https://test1.7lore.com/knight-trainer/sir-dinadan-the-humorous" },
    { name: "Sir Palamedes the Saracen", url: "https://test1.7lore.com/knight-trainer/sir-palamedes-the-saracen" },
    { name: "Sir Bedivere the Bold", url: "https://test1.7lore.com/knight-trainer/sir-bedivere-the-bold" },
    { name: "Sir Cador of Cornwall", url: "https://test1.7lore.com/knight-trainer/sir-cador-of-cornwall" },
    { name: "Sir Galahad the Pure", url: "https://test1.7lore.com/knight-trainer/sir-galahad-the-pure" },
    { name: "Sir Lucan the Butler", url: "https://test1.7lore.com/knight-trainer/sir-lucan-the-butler" },
    { name: "Sir Marrok the Werewolf Knight", url: "https://test1.7lore.com/knight-trainer/sir-marrok-the-werewolf-knight" },
    { name: "Sir Gaheris of Orkney", url: "https://test1.7lore.com/knight-trainer/sir-gaheris-of-orkney" },
    { name: "Sir William Marshal 1st Earl of Pembroke", url: "https://test1.7lore.com/knight-trainer/sir-william-marshal-1st-earl-of-pembroke" },
    { name: "Sir Dodinas le Savage", url: "https://test1.7lore.com/knight-trainer/sir-dodinas-le-savage" },
    { name: "Sir Agravaine the Proud", url: "https://test1.7lore.com/knight-trainer/sir-agravaine-the-proud" },
    { name: "Sir Bors de Ganis", url: "https://test1.7lore.com/knight-trainer/sir-bors-de-ganis" },
    { name: "Sir Gawain of Orkney", url: "https://test1.7lore.com/knight-trainer/sir-gawain-of-orkney" },
    { name: "Sir Balin le Savage", url: "https://test1.7lore.com/knight-trainer/sir-balin-le-savage" },
    { name: "Sir Tristan of Lyonesse", url: "https://test1.7lore.com/knight-trainer/sir-tristan-of-lyonesse" },
    { name: "Sir Lamorak de Galis", url: "https://test1.7lore.com/knight-trainer/sir-lamorak-de-galis" },
    { name: "Sir Pelleas the Younger", url: "https://test1.7lore.com/knight-trainer/sir-pelleas-the-younger" },
    { name: "Sir Tor the Bastard", url: "https://test1.7lore.com/knight-trainer/sir-tor-the-bastard" },
    { name: "Sir Safir the Saracen", url: "https://test1.7lore.com/knight-trainer/sir-safir-the-saracen" },
    { name: "Sir Constantine of Britain", url: "https://test1.7lore.com/knight-trainer/sir-constantine-of-britain" },
    { name: "Sir Garlon the Invisible Knight", url: "https://test1.7lore.com/knight-trainer/sir-garlon-the-invisible-knight" },
    { name: "Sir Lancelot du Lac", url: "https://test1.7lore.com/knight-trainer/sir-lancelot-du-lac" },
    { name: "Sir Gareth of Orkney", url: "https://test1.7lore.com/knight-trainer/sir-gareth-of-orkney" },
    { name: "Sir Brandiles the Bold", url: "https://test1.7lore.com/knight-trainer/sir-brandiles-the-bold" },
    { name: "Sir Segwarides the Jealous", url: "https://test1.7lore.com/knight-trainer/sir-segwarides-the-jealous" },
    { name: "Sir Pelleas the Gentle", url: "https://test1.7lore.com/knight-trainer/sir-pelleas-the-gentle" },
    { name: "Black Hawk", url: "https://test1.7lore.com/native-american-trainer/black-hawk" },
    { name: "Tecumseh", url: "https://test1.7lore.com/native-american-trainer/tecumseh" },
    { name: "Kamiakin", url: "https://test1.7lore.com/native-american-trainer/kamiakin" },
    { name: "Osceola", url: "https://test1.7lore.com/native-american-trainer/osceola" },
    { name: "Pontiac", url: "https://test1.7lore.com/native-american-trainer/pontiac" },
    { name: "Black Kettle", url: "https://test1.7lore.com/native-american-trainer/black-kettle" },
    { name: "Dull Knife", url: "https://test1.7lore.com/native-american-trainer/dull-knife" },
    { name: "Victorio", url: "https://test1.7lore.com/native-american-trainer/victorio" },
    { name: "Pushmataha", url: "https://test1.7lore.com/native-american-trainer/pushmataha" },
    { name: "Sitting Bull", url: "https://test1.7lore.com/native-american-trainer/sitting-bull" },
    { name: "Roman Nose", url: "https://test1.7lore.com/native-american-trainer/roman-nose" },
    { name: "Cornstalk", url: "https://test1.7lore.com/native-american-trainer/cornstalk" },
    { name: "Geronimo", url: "https://test1.7lore.com/native-american-trainer/geronimo" },
    { name: "Quanah Parker", url: "https://test1.7lore.com/native-american-trainer/quanah-parker" },
    { name: "Sequoyah", url: "https://test1.7lore.com/native-american-trainer/sequoyah" },
    { name: "Gall", url: "https://test1.7lore.com/native-american-trainer/gall" },
    { name: "American Horse", url: "https://test1.7lore.com/native-american-trainer/american-horse" },
    { name: "Leschi", url: "https://test1.7lore.com/native-american-trainer/leschi" },
    { name: "Nana", url: "https://test1.7lore.com/native-american-trainer/nana" },
    { name: "Ten Bears", url: "https://test1.7lore.com/native-american-trainer/ten-bears" },
    { name: "Little Turtle", url: "https://test1.7lore.com/native-american-trainer/little-turtle" },
    { name: "Chief Joseph", url: "https://test1.7lore.com/native-american-trainer/chief-joseph" },
    { name: "Looking Glass", url: "https://test1.7lore.com/native-american-trainer/looking-glass" },
    { name: "Red Cloud", url: "https://test1.7lore.com/native-american-trainer/red-cloud" },
    { name: "Blue Jacket", url: "https://test1.7lore.com/native-american-trainer/blue-jacket" },
    { name: "Lozen", url: "https://test1.7lore.com/native-american-trainer/lozen" },
    { name: "Cochise", url: "https://test1.7lore.com/native-american-trainer/cochise" },
    { name: "Crazy Horse", url: "https://test1.7lore.com/native-american-trainer/crazy-horse" },
    { name: "Mangas Coloradas", url: "https://test1.7lore.com/native-american-trainer/mangas-coloradas" },
    { name: "King Philip Metacomet", url: "https://test1.7lore.com/native-american-trainer/king-philip-metacomet" }
];

/// Replace your getTrainerPngNumber function with this FIXED version
const getTrainerPngNumber = (trainerName) => {
    console.log('🔍 Looking for trainer:', trainerName);

    if (!trainerName) {
        console.log('❌ No trainer name provided');
        return null;
    }

    let foundIndex = -1;
    trainerData.forEach((trainer, index) => {
        if (trainer.name.toLowerCase() === trainerName.toLowerCase()) {
            console.log('✅ Found exact match:', trainer.name, 'at index:', index);
            foundIndex = index;
        }
    });

    if (foundIndex === -1) {
        console.log('❌ No exact match found for:', trainerName);
        console.log('📋 Available knight trainers in array:');
        trainerData.forEach((trainer, index) => {
            if (trainer.name.toLowerCase().includes('tristan')) {
                console.log(`  ${index + 1}: ${trainer.name}`);
            }
        });
        return null;
    }

    const pngNumber = foundIndex + 1;
    console.log(`🎯 PNG number for ${trainerName}: ${pngNumber}`);
    return pngNumber;
};

// Challenge Modal Component
const ChallengeModal = ({ isOpen, onClose, workout, onSendChallenge }) => {
    const [challengeEmail, setChallengeEmail] = useState('');
    const [challengerName, setChallengerName] = useState('');
    const [personalMessage, setPersonalMessage] = useState('');
    const [isSending, setIsSending] = useState(false);

    // Load saved challenger name
    useEffect(() => {
        const savedUserData = localStorage.getItem('bumfitUserData');
        if (savedUserData) {
            try {
                const userData = JSON.parse(savedUserData);
                if (userData.name) {
                    setChallengerName(userData.name);
                } else if (userData.email) {
                    // Extract name from email if no name saved
                    const emailName = userData.email.split('@')[0];
                    setChallengerName(emailName);
                }
            } catch (e) {
                console.error('Error loading user data:', e);
            }
        }
    }, [isOpen]);

    const handleSendChallenge = async () => {
        if (!challengeEmail || !challengeEmail.includes('@')) {
            alert('Please enter a valid email address');
            return;
        }

        if (!challengerName.trim()) {
            alert('Please enter your name');
            return;
        }

        setIsSending(true);

        try {
            await onSendChallenge({
                challengeEmail,
                challengerName: challengerName.trim(),
                personalMessage: personalMessage.trim(),
                workout
            });

            // Reset form
            setChallengeEmail('');
            setPersonalMessage('');
            onClose();

            alert('🔥 Challenge sent! Your friend will receive the workout challenge in their inbox.');
        } catch (error) {
            alert('Failed to send challenge: ' + error.message);
        } finally {
            setIsSending(false);
        }
    };

    if (!isOpen) return null;

    return (
        <div className="modal-overlay">
            <div className="challenge-modal">
                <div className="modal-header">
                    <h2>🔥 Challenge Someone!</h2>
                    <p>Send your workout as a challenge to a friend</p>
                </div>

                <div className="modal-content">
                    <div className="input-group">
                        <label htmlFor="challengerName">
                            <span className="label-text">Your Name</span>
                            <span className="required">*</span>
                        </label>
                        <input
                            id="challengerName"
                            type="text"
                            value={challengerName}
                            onChange={(e) => setChallengerName(e.target.value)}
                            placeholder="Your name"
                            disabled={isSending}
                        />
                    </div>

                    <div className="input-group">
                        <label htmlFor="challengeEmail">
                            <span className="label-text">Friend's Email</span>
                            <span className="required">*</span>
                        </label>
                        <input
                            id="challengeEmail"
                            type="email"
                            value={challengeEmail}
                            onChange={(e) => setChallengeEmail(e.target.value)}
                            placeholder="friend@email.com"
                            disabled={isSending}
                            autoFocus
                        />
                    </div>

                    <div className="input-group">
                        <label htmlFor="personalMessage">
                            <span className="label-text">Personal Message (Optional)</span>
                        </label>
                        <textarea
                            id="personalMessage"
                            value={personalMessage}
                            onChange={(e) => setPersonalMessage(e.target.value)}
                            placeholder="Add a personal challenge message..."
                            disabled={isSending}
                            rows="3"
                        />
                    </div>

                    <div className="challenge-preview">
                        <h4>🎯 What they'll receive:</h4>
                        <div className="preview-content">
                            <p>✅ Your complete workout challenge</p>
                            <p>💪 Exercise list with rep counts</p>
                            <p>🔥 Invitation to try BUMFIT</p>
                            <p>⚡ Direct link to start the challenge</p>
                        </div>
                    </div>
                </div>

                <div className="modal-buttons">
                    <button
                        className="send-challenge-button"
                        onClick={handleSendChallenge}
                        disabled={isSending}
                    >
                        {isSending ? (
                            <>
                                <span className="spinner"></span>
                                Sending Challenge...
                            </>
                        ) : (
                            <>
                                🔥 Send Challenge!
                            </>
                        )}
                    </button>

                    <button
                        className="cancel-button"
                        onClick={onClose}
                        disabled={isSending}
                    >
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    );
};

// Email service for challenges
const sendWorkoutChallenge = async (challengeData) => {
    if (!window.emailjs) {
        throw new Error('EmailJS not loaded');
    }

    // Initialize EmailJS if not already done
    if (!window.emailjs._initialized) {
        window.emailjs.init('Ke_xwVYFVvuHuFKnX'); // Your public key
        window.emailjs._initialized = true;
    }

    const { challengeEmail, challengerName, personalMessage, workout } = challengeData;

    // Determine workout type
    const workoutType = determineWorkoutType(workout);
    const isTrainerProgram = workout.isTrainerProgram && workout.trainerName;
    const isBattleMode = workout.battleCode || workout.totalScore !== undefined;

    // Create challenge message
    let challengeWorkoutSummary = `🔥 WORKOUT CHALLENGE FROM ${challengerName.toUpperCase()}! 🔥

${personalMessage ? `Personal Message: "${personalMessage}"\n\n` : ''}Hey! ${challengerName} has challenged you to complete their workout on BUMFIT!

📊 CHALLENGE DETAILS:
• Type: ${workoutType.displayName}
• Exercises: ${workout.exercises?.length || 0} total exercises
• Reps per Exercise: ${workout.repCount || 10}
• Total Reps: ${workout.totalReps || 'N/A'}
${isTrainerProgram ? `• Trainer: ${workout.trainerName}\n• Program: ${workout.programName}\n• Intensity: ${workout.intensityLabel} (${workout.intensityLevel}%)` : ''}
${isBattleMode ? `• Battle Code: ${workout.battleCode}\n• Score to Beat: ${workout.totalScore}` : ''}

💪 EXERCISES TO COMPLETE:
${workout.exercises?.map((exercise, index) => {
        const exerciseName = typeof exercise === 'string' ? exercise : exercise.name;
        return `${index + 1}. ${exerciseName} - ${workout.repCount || 10} reps`;
    }).join('\n') || 'No exercises listed'}

🎯 ACCEPT THE CHALLENGE:
Ready to take on ${challengerName}'s workout? 

👉 Go to bumfit.com to start your challenge!
👉 Create your own workouts and challenge friends back!
👉 Track your progress and build your fitness routine!

────────────────────────────────
🔥 BUMFIT - Train - Build - Battle 🔥
bumfit.com - Where every word is a workout!
Join thousands building fitness one workout at a time.
────────────────────────────────

Can you beat ${challengerName}'s workout? Accept the challenge at bumfit.com!`;

    // Email parameters
    const emailParams = {
        to_email: challengeEmail,
        workout_title: `🔥 Workout Challenge from ${challengerName}!`,
        exercise_count: workout.exercises?.length || 0,
        total_reps: workout.totalReps || 'N/A',
        workout_summary: challengeWorkoutSummary,
        challenger_name: challengerName,
        timestamp: new Date().toLocaleString(),
        // BCC yourself to track challenges
        bcc_email: 'redhubcap@gmail.com' // Replace with your actual email
    };

    try {
        const response = await window.emailjs.send(
            'service_d5cc5ls',     // Your service ID
            'template_af7akil',    // Use your existing template or create new one
            emailParams,
            'Ke_xwVYFVvuHuFKnX'    // Your public key
        );

        console.log('Challenge email sent successfully:', response);
        return { success: true, response };
    } catch (error) {
        console.error('Challenge email error:', error);
        throw new Error('Failed to send challenge: ' + (error.text || error.message));
    }
};

// Helper function (you already have this)
// Replace the determineWorkoutType function in SavedWorkouts.js with this complete version:

const determineWorkoutType = (workout) => {
    // Check for Japan trainer workouts
    if (workout.isJapanTrainer || workout.category === 'japan-trainer' || workout.workoutType === 'japan-trainer') {
        return {
            displayName: `${workout.programName || 'Japan Training'} with ${workout.trainerName || 'Japan Master'}`,
            backgroundColor: "#8B4513", // Japan brown color
            textColor: "#F5E6D3", // Japan cream text
            isTrainerProgram: true,
            isJapanTrainer: true
        };
    }

    // Check for Hero trainer workouts
    if (workout.isHeroTrainer || workout.category === 'hero' || workout.workoutType === 'hero-trainer') {
        return {
            displayName: `${workout.programName || 'Hero Training'} with ${workout.trainerName || 'Hero'}`,
            backgroundColor: "#DC143C", // Hero red color
            textColor: "#FFFFFF",
            isTrainerProgram: true,
            isHeroTrainer: true
        };
    }

    // Check for other trainer programs
    if (workout.isTrainerProgram && workout.trainerName) {
        // Handle different trainer categories
        if (workout.category === 'bodyweight' || workout.workoutType === 'bodyweight-trainer') {
            return {
                displayName: `${workout.programName || 'Bodyweight Training'} with ${workout.trainerName}`,
                backgroundColor: "#4CAF50",
                textColor: "#FFFFFF",
                isTrainerProgram: true
            };
        }

        if (workout.category === 'strength' || workout.workoutType === 'strength-trainer') {
            return {
                displayName: `${workout.programName || 'Strength Training'} with ${workout.trainerName}`,
                backgroundColor: "#FF5722",
                textColor: "#FFFFFF",
                isTrainerProgram: true
            };
        }

        if (workout.category === 'bands' || workout.workoutType === 'bands-trainer') {
            return {
                displayName: `${workout.programName || 'Bands Training'} with ${workout.trainerName}`,
                backgroundColor: "#9C27B0",
                textColor: "#FFFFFF",
                isTrainerProgram: true
            };
        }

        if (workout.category === 'everything' || workout.workoutType === 'everything-trainer') {
            return {
                displayName: `${workout.programName || 'Everything Training'} with ${workout.trainerName}`,
                backgroundColor: "#FF9800",
                textColor: "#FFFFFF",
                isTrainerProgram: true
            };
        }

        if (workout.category === 'advanced-bodyweight' || workout.workoutType === 'advanced-trainer') {
            return {
                displayName: `${workout.programName || 'Advanced Training'} with ${workout.trainerName}`,
                backgroundColor: "#E91E63",
                textColor: "#FFFFFF",
                isTrainerProgram: true
            };
        }

        // Generic trainer program fallback
        return {
            displayName: `${workout.programName || 'Trainer Program'} with ${workout.trainerName}`,
            backgroundColor: "#FF6B35",
            textColor: "#FFFFFF",
            isTrainerProgram: true
        };
    }

    // Check for Battle Mode
    if (workout.battleCode || workout.totalScore !== undefined || workout.workoutType === 'battle') {
        return {
            displayName: "Battle Mode",
            backgroundColor: "#8E24AA",
            textColor: "#FFFFFF",
            isBattleMode: true
        };
    }

    // Check for Hero Selection (non-trainer)
    if (workout.workoutType === 'hero' && !workout.trainerName) {
        return {
            displayName: "Hero Selection",
            backgroundColor: "#E91E63",
            textColor: "#FFFFFF"
        };
    }

    // Check for specific workout types
    const workoutTypeMapping = {
        'bodyweight': {
            displayName: "Bodyweight",
            backgroundColor: "#4CAF50",
            textColor: "#FFFFFF"
        },
        'bands': {
            displayName: "Resistance Bands",
            backgroundColor: "#9C27B0",
            textColor: "#FFFFFF"
        },
        'strength': {
            displayName: "Strength Training",
            backgroundColor: "#FF5722",
            textColor: "#FFFFFF"
        },
        'advanced-bodyweight': {
            displayName: "Advanced Bodyweight",
            backgroundColor: "#E91E63",
            textColor: "#FFFFFF"
        },
        'everything': {
            displayName: "Everything Mode",
            backgroundColor: "#FF9800",
            textColor: "#FFFFFF"
        }
    };

    if (workout.workoutType && workoutTypeMapping[workout.workoutType]) {
        return workoutTypeMapping[workout.workoutType];
    }

    // Analyze muscle groups for custom workouts
    if (workout.muscleGroups && workout.muscleGroups.length > 0) {
        const muscleGroupsStr = workout.muscleGroups.join('').toLowerCase();

        if (muscleGroupsStr.includes('upper') && muscleGroupsStr.includes('lower')) {
            return {
                displayName: "Full Body Custom",
                backgroundColor: "#FF9800",
                textColor: "#FFFFFF"
            };
        } else if (muscleGroupsStr.includes('upper')) {
            return {
                displayName: "Upper Body Custom",
                backgroundColor: "#2196F3",
                textColor: "#FFFFFF"
            };
        } else if (muscleGroupsStr.includes('lower')) {
            return {
                displayName: "Lower Body Custom",
                backgroundColor: "#4CAF50",
                textColor: "#FFFFFF"
            };
        } else if (muscleGroupsStr.includes('core')) {
            return {
                displayName: "Core Custom",
                backgroundColor: "#FF5722",
                textColor: "#FFFFFF"
            };
        }
    }

    // Default fallback
    return {
        displayName: "Custom Workout",
        backgroundColor: "#2196F3",
        textColor: "#FFFFFF"
    };
};

const SavedWorkouts = () => {
    const navigate = useNavigate();
    const [savedWorkouts, setSavedWorkouts] = useState([]);
    const [showChallengeModal, setShowChallengeModal] = useState(false);
    const [selectedWorkout, setSelectedWorkout] = useState(null);

    useEffect(() => {
        loadSavedWorkouts();
    }, []);

    const loadSavedWorkouts = () => {
        const workouts = JSON.parse(localStorage.getItem('workoutHistory') || '[]');
        // Fix workouts that don't have dates or have invalid dates
        const updatedWorkouts = workouts.map(workout => {
            if (!workout.date || isNaN(new Date(workout.date).getTime())) {
                return {
                    ...workout,
                    date: new Date().toISOString() // Add current date as fallback
                };
            }
            return workout;
        });

        // Save the updated workouts back to localStorage ONLY if changes were made
        if (JSON.stringify(workouts) !== JSON.stringify(updatedWorkouts)) {
            localStorage.setItem('workoutHistory', JSON.stringify(updatedWorkouts));
        }

        // Display most recent first (reverse chronologically)
        setSavedWorkouts([...updatedWorkouts].reverse());
    };

    // Handle challenge button click
    const handleChallengeWorkout = (workout) => {
        setSelectedWorkout(workout);
        setShowChallengeModal(true);
    };

    // Handle sending challenge
    const handleSendChallenge = async (challengeData) => {
        await sendWorkoutChallenge(challengeData);
    };

    // Your existing functions (shareWorkout, deleteWorkout, etc.)...
    const shareWorkout = (workout) => {
        // Your existing shareWorkout function
    };

    const deleteWorkout = (workoutToDelete, index) => {
        // Remove the workout at the given index
        const updatedWorkouts = savedWorkouts.filter((_, i) => i !== index);
        setSavedWorkouts(updatedWorkouts);

        // Save back to localStorage (reverse again since display is reversed)
        localStorage.setItem('workoutHistory', JSON.stringify([...updatedWorkouts].reverse()));
    };

    const formatDate = (dateString) => {
        try {
            // Ensure we have a valid date
            let date = dateString ? new Date(dateString) : new Date();

            // Double-check if date is valid
            if (isNaN(date.getTime())) {
                date = new Date(); // Fallback to current date
            }

            return date.toLocaleDateString('en-US', {
                weekday: 'short',
                year: 'numeric',
                month: 'short',
                day: 'numeric',
                hour: 'numeric',
                minute: '2-digit'
            });
        } catch (e) {
            return 'Recent Workout';
        }
    };

    return (
        <div className="saved-workouts-container">
            <header className="saved-workouts-header">
                <button className="back-button" onClick={() => navigate('/')}>
                    ← Back to Home
                </button>
                <h1>Saved Workouts</h1>
                <p>{savedWorkouts.length} workout{savedWorkouts.length !== 1 ? 's' : ''} saved</p>
            </header>

            {savedWorkouts.length === 0 ? (
                <div className="no-workouts">
                    <p>No saved workouts yet!</p>
                    <p>Complete a workout and save it to see it here.</p>
                    <button className="start-workout-button" onClick={() => navigate('/')}>
                        Start Your First Workout
                    </button>
                </div>
            ) : (
                <div className="workouts-list">
                    {savedWorkouts.map((workout, index) => {
                        const workoutType = determineWorkoutType(workout);
                        const exerciseLines = workout.exercises || [];
                        const isBattleMode = workout.battleCode || workout.totalScore !== undefined;

                        return (
                            <div
                                key={index}
                                className="workout-item"
                                style={{
                                    backgroundColor: workoutType.backgroundColor,
                                    color: workoutType.textColor
                                }}
                            >
                                <div className="workout-header">
                                    <div className="workout-date">
                                        <strong>Date: {formatDate(workout.date)}</strong>
                                    </div>
                                    <div className="delete-container">
                                        <button
                                            className="delete-button"
                                            onClick={() => deleteWorkout(workout, index)}
                                        >
                                            🗑️
                                        </button>
                                        <span className="delete-text">delete workout</span>
                                    </div>
                                </div>

                                <div className="workout-type">
                                    {workoutType.isTrainerProgram && workout.trainerName && (
                                        <div className="trainer-thumbnail-container">
                                            <div className="trainer-thumbnail">
                                                <img
                                                    src={`/assets/images/${getTrainerPngNumber(workout.trainerName)}.png`}
                                                    alt={workout.trainerName}
                                                    onError={(e) => {
                                                        e.target.style.display = 'none';
                                                        e.target.nextSibling.style.display = 'flex';
                                                    }}
                                                />
                                                <div className="trainer-fallback" style={{display: 'none'}}>
                                                    👤
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                    <div className="workout-type-content">
                                        <strong>Type: {workoutType.displayName}</strong>
                                        {workoutType.isTrainerProgram && (
                                            <div className="trainer-program-info">
                                                <div className="trainer-name">Trainer: {workout.trainerName}</div>
                                                <div className="intensity-info">
                                                    Intensity: {workout.intensityLabel} ({workout.intensityLevel}%)
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>

                                <div className="workout-stats">
                                    <div className="stat-row">
                                        <span>Total Reps: {workout.totalReps || 'N/A'}</span>
                                        <span>Exercises: {exerciseLines.length}</span>
                                    </div>
                                    {isBattleMode && (
                                        <div className="stat-row">
                                            <span>Score: {workout.totalScore || 'N/A'}</span>
                                        </div>
                                    )}
                                </div>

                                {exerciseLines.length > 0 && (
                                    <div className="exercises-section">
                                        <strong>Exercises:</strong>
                                        <div className="exercises-list">
                                            {exerciseLines.slice(0, 5).map((exercise, exerciseIndex) => (
                                                <div key={exerciseIndex} className="exercise-item">
                                                    • {typeof exercise === 'string' ? exercise : exercise.name} ({workout.repCount || 'N/A'} reps)
                                                </div>
                                            ))}
                                            {exerciseLines.length > 5 && (
                                                <div className="exercise-item">
                                                    ... and {exerciseLines.length - 5} more
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                )}

                                <div className="workout-actions">
                                    <button
                                        className="challenge-button"
                                        onClick={() => handleChallengeWorkout(workout)}
                                    >
                                        🔥 Challenge Someone
                                    </button>

                                    <button
                                        className="share-button"
                                        onClick={() => shareWorkout(workout)}
                                    >
                                        {isBattleMode ? '⚔️ Share Battle' : '📧 Share Workout'}
                                    </button>
                                </div>
                            </div>
                        );
                    })}
                </div>
            )}

            <ChallengeModal
                isOpen={showChallengeModal}
                onClose={() => setShowChallengeModal(false)}
                workout={selectedWorkout}
                onSendChallenge={handleSendChallenge}
            />
        </div>
    );
};

export default SavedWorkouts;